// extracted by mini-css-extract-plugin
module.exports = {"at-opancalculator":"piano_at-opancalculator__2sc2u"};